import React from 'react'

export const BibliographyTypes = [
  {
    name: 'list',
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/bibliographyTypes/BibliographyTypesList'),
    ),
    path: '/admin/pedagogical-parameters/bibliography-types',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/bibliographyTypes/BibliographyTypesCreate'),
    ),
    path: '/admin/pedagogical-parameters/bibliography-types/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/bibliographyTypes/BibliographyTypesEdit'),
    ),
    path: '/admin/pedagogical-parameters/bibliography-types/edit/:bibliographyTypeId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
